
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg","fill":"#FFF"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.823 0L15 11.823 3.176 0-.088 3.353l11.735 11.735L-.088 26.912l3.264 3.353L15 18.44l11.823 11.824 3.265-3.353-11.735-11.824L30.088 3.353 26.823 0z"}})])
          )
        }
      }
    